export const NEXT_KEYS = [
  'ArrowRight',
  'Right',
  'ArrowDown',
  'Down',
  'PageDown',
];
export const PREVIOUS_KEYS = ['ArrowLeft', 'Left', 'ArrowUp', 'Up', 'PageUp'];
